import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import SearchMenu from './searchMenu';
import { getUserDetails } from '../../../../services/common/util';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import { auditEnums, serviceConstants } from '../../../../services/common/constants';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { fetchQcResults } from '../../../../services/clinicPortalServices/qcResultService';
import { fetchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService';
import moment from 'moment';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import toastr from 'toastr';
import Statusupdatepopup from './qcStatusupdatePopup';
import { qcResultTypes } from '../../../../services/common/optionsData.js';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class QcResultGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            StatusupdatePopup: false,
            selectedRows: [],
            UniqueQcRuns: [],
            columnDefs: [
                {
                    headerName: 'QC Run',
                    minWidth: 150,
                    resizable: true,
                    field: 'qc_run_index'
                },
                {
                    headerName: 'Analyte',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyte_id ? params.data.analyte_id.name : '';
                    }
                },
                {
                    headerName: 'Control Type',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id) {
                            return params.data.qc_sample_id.controlType;
                        }
                    }
                },
                {
                    headerName: 'Target Value',
                    minWidth: 150,
                    resizable: true,
                    field: 'targetValue'
                },
                {
                    headerName: 'Value',
                    minWidth: 150,
                    resizable: true,
                    field: 'value'
                },
                {
                    headerName: 'Unit',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyte_id ? params.data.analyte_id.units : '';
                    }
                },
                {
                    headerName: 'Passed?',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue) {
                            return Math.abs(params.data.value - params.data.targetValue) <=
                                Number(params.data.targetValue) * 0.2
                                ? 'Yes'
                                : 'No';
                        }
                    }
                },
                {
                    headerName: 'Within 10% Target?',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue) {
                            return Math.abs(params.data.value - params.data.targetValue) <=
                                Number(params.data.targetValue) * 0.1
                                ? 'Yes'
                                : 'No';
                        }
                    }
                },
                {
                    headerName: 'Within 20% Target?',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue) {
                            return Math.abs(params.data.value - params.data.targetValue) <=
                                Number(params.data.targetValue) * 0.2
                                ? 'Yes'
                                : 'No';
                        }
                    }
                },
                {
                    headerName: 'State',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        const value = params?.data?.state;
                        if (value === undefined || value === null || value === '') {
                            return qcResultTypes[0] || '';
                        }
                        return value;
                    },
                    field: 'state'
                },
                {
                    headerName: 'QC Group Valid?',
                    minWidth: 150,
                    resizable: true,
                    field: 'qc_group_valid'
                },
                {
                    headerName: 'QC Grouping',
                    minWidth: 150,
                    resizable: true,
                    field: 'qc_grouping',
                    valueGetter: (params) => {
                        return params.data.analyte_id ? 'for ' + params.data.analyte_id.name : '';
                    }
                },
                {
                    headerName: 'Run Date/Time',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.run_date) {
                            return moment(params.data.run_date, 'YYYYMMDDHHmmss').format('MM/DD/YYYY hh:mm A');
                        }
                    }
                },
                {
                    headerName: 'Instrument',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.instrument_id) {
                            return params.data.instrument_id.name;
                        }
                    }
                },
                {
                    headerName: 'QC Sample',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id) {
                            return params.data.qc_sample_id.name;
                        }
                    }
                },
                {
                    headerName: 'Lot Number',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id) {
                            return params.data.qc_sample_id.lotNumber;
                        }
                    }
                },
                {
                    headerName: 'Lot Expiration Date',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id && params.data.qc_sample_id.lotExpirationDate) {
                            return moment(params.data.qc_sample_id.lotExpirationDate, 'YYYYMMDD').format('MM/DD/YYYY');
                        }
                    }
                },
                {
                    headerName: 'Creation Date',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return moment
                            .tz(params.data.createdAt, serviceConstants.SYSTEM_TIME_ZONE)
                            .format('MM/DD/YYYY hh:mm:ss A');
                    }
                },
                {
                    headerName: 'Created By',
                    minWidth: 150,
                    resizable: true,
                    field: 'created_by'
                },
                {
                    headerName: 'Comments',
                    minWidth: 150,
                    resizable: true,
                    field: 'comment'
                }
            ],
            components: {},
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this },
            qcRanges: []
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridData();
    };

    onReviewClick = () => {
        // gather selected rows from ag-grid
        const selectedNodes = this.gridApi ? this.gridApi.getSelectedNodes() : [];
        const selectedRows = selectedNodes.map((node) => node.data);
        if (!selectedRows || selectedRows.length === 0) {
            toastr.warning('No QC results selected.');
            return;
        }
        // open popup and pass selected rows        
        this.setState({ StatusupdatePopup: true, selectedRows });
    };

    updateGridSelection = () => {
        const { selectedQcRuns } = this.state;
        if (!this.gridApi) return;

        const currentPage = this.gridApi.paginationGetCurrentPage();
        const pageSize = this.gridApi.paginationGetPageSize();

        let firstMatchNode = null;

        this.gridApi.forEachNode((node) => {            
            if (selectedQcRuns.includes(node.data.qc_run_index)) {
                if (!firstMatchNode) firstMatchNode = node;
            }
        });

        // If nothing is selected, just clear everything
        if (!selectedQcRuns?.length) {
            this.gridApi.deselectAll();
            return;
        }

        // Calculate which page contains the first matching node
        const firstPage = Math.floor(firstMatchNode.rowIndex / pageSize);

        // Move to the correct page if needed
        if (firstPage !== currentPage) {
            this.gridApi.paginationGoToPage(firstPage);
            setTimeout(() => {
                this.gridApi.forEachNodeAfterFilterAndSort((node) => {
                    const shouldSelect = selectedQcRuns.includes(node.data.qc_run_index);
                    node.setSelected(shouldSelect);
                });
                this.gridApi.ensureNodeVisible(firstMatchNode, 'middle');
            }, 150);
        } else {
            // On current page — select and unselect properly
            this.gridApi.forEachNodeAfterFilterAndSort((node) => {
                const shouldSelect = selectedQcRuns.includes(node.data.qc_run_index);
                node.setSelected(shouldSelect);
            });
        }
    };

    handleQcRunChange = (selectedQcRuns) => {        
        this.setState({ selectedQcRuns }, () => {
            this.updateGridSelection();
        });
    };

    computePassFlags(qcResults) {
        const results = qcResults.map((item) => {
            const value = Number(item.value);
            const target = Number(item.targetValue);

            const isPassed =
                item.value && item.targetValue
                    ? Math.abs(value - target) <= target * 0.2
                    : false;

            return { ...item, is_passed: isPassed };
        });

        return this.computeGroupLevelPassStatus(results);
    }

    getUniqueQcRunIndexes = (qcResults) => {
        return [...new Set(qcResults.map(item => item.qc_run_index))];
    };


    computeGroupLevelPassStatus = (qcResults) => {
        // Group results by qc_run_index
        const grouped = qcResults.reduce((acc, item) => {
            const key = item.qc_run_index;
            if (!acc[key]) acc[key] = [];
            acc[key].push(item);
            return acc;
        }, {});

        // Loop through each group and calculate overall pass/fail
        Object.keys(grouped).forEach((runIndex) => {
            const group = grouped[runIndex];
            const total = group.length;
            const passed = group.filter((x) => x.is_passed === true || x.is_passed === "Yes").length;

            const overallStatus = passed / total >= 2 / 3 ? "Passed" : "Not Valid";

            // Assign same group-level result to all rows
            group.forEach((item) => (item.qc_group_valid = overallStatus));
        });

        return qcResults;
    };


    loadGridData = () => {
        fetchQcRanges().then((res) => {
            this.setState({ qcRanges: res.data }, () => {
                fetchQcResults().then((res) => {
                    res.data.map((qcResultItem) => {
                        let matchingRange = this.state.qcRanges.find(
                            (item) =>
                                item.analyteId?._id === qcResultItem.analyte_id?._id &&
                                item.controlType === qcResultItem.qc_sample_id?.controlType
                        );
                        qcResultItem.targetValue = matchingRange ? matchingRange.targetValue : null;
                    });
                    const data = res.data;
                    const updatedData = this.computePassFlags(data);
                    const uniqueQcRuns = this.getUniqueQcRunIndexes(updatedData);
                    this.setState({ rowData: updatedData, UniqueQcRuns: uniqueQcRuns });
                });
            });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'QC_Result_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'QC Results'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.QcResultGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.QcResultGridExported
        };
        createAudit(auditData);
    };

    render() {
        let columnDefs = this.state.columnDefs;
        return (
            <div className="clinic-contain">
                <SearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    context={this.state.context}
                    onReviewClick={this.onReviewClick}
                    uniqueQcRuns={this.state.UniqueQcRuns}
                    onQcRunChange={this.handleQcRunChange}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                    rowSelection={{ mode: 'multiRow' }}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
                <Statusupdatepopup
                    show={this.state.StatusupdatePopup}
                    handleClose={() => this.setState({ StatusupdatePopup: false })}
                    selectedRows={this.state.selectedRows}
                    loadGridData={this.loadGridData}
                />
            </div>
        );
    }
}

export default QcResultGrid;
